import { useEffect } from 'react';
import styled from '@emotion/styled';
import appConfig from 'app-config';
import LoadingIndicatorBase from 'src/components/LoadingIndicator';
const LoadingIndicator = styled(LoadingIndicatorBase)`
  position: fixed;
  color: ${({
  theme
}) => theme.color.content7};
`;
export default function CommunityGuidelinesView() {
  useEffect(() => {
    window.location.replace(appConfig.helpCenterArticleUrls.communityGuidelines);
  }, []);
  return <LoadingIndicator size={32} data-sentry-element="LoadingIndicator" data-sentry-component="CommunityGuidelinesView" data-sentry-source-file="CommunityGuidelines.tsx" />;
}